export default function (state, value) {
    let item = {
        id: ''+new Date().getTime(),
        name: 'Фильтр ' + (state.filters.length + 1),
        searchClick: true,
        dateType: 1,
        dateStep: 1,
        dateInt: 0,
        dateRound: false,
        SumFrom: 0,
        SumTo: 0,
        AvailableSumFrom: 0,
        AvailableSumTo: 0,
        CurrencyIds: [],
        ContragentId: [],
        ContragentName: '',
        ContragentSearchTypeId: '',
        Number: '',
        Type: '',
        OwnerLegalEntityId: '',
        IsUsed: false,
        IsPayed: false,
    };
    if (value) {
        for (let k in value) {
            if (typeof item[k] !== 'undefined') item[k] = value[k];
        }
    }
    state.filters.push(item);
    if (!value) {
        state.filter = item.id;
    }
}